export enum ChartType {
    AREA = "area",
    AREA_SPLINE = "areaSpline",
    BAR = "bar",
    LINE = "line"
}